export const ItemTypes = {
    ANSWER: "answer",
    BLANK: "blank",
    BEFORE_BLANK: "BEFORE_BLANK",
    AFTER_BLANK: "AFTER_BLANK",
    NOT_BLANK: "NOT_BLANK"
  };

  